import type { FC, ReactNode } from 'react'

import { useRef } from 'react'
import { gsap, useGSAP } from '@/lib/motion'
import MahoniaSprig from '@/components/landing/decor/mahonia'

// Scene change between STORY and STREAM: a large Mahonia confusa branch crosses the screen while
// the sky colour shifts and the observation log scrolls past in outline letters.
const PlantInterlude: FC = (): ReactNode => {
    const rootRef = useRef<HTMLDivElement>(null)

    useGSAP(() => {
        const root = rootRef.current

        if (!root) return

        const q = gsap.utils.selector(root)
        const mm = gsap.matchMedia()

        mm.add('(prefers-reduced-motion: no-preference)', () => {
            const scroll = { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 1, invalidateOnRefresh: true }

            gsap.fromTo(q('[data-sweep="main"]'), { x: () => window.innerWidth * 0.95, rotate: -98 }, { x: () => -window.innerWidth * 1.05, rotate: -82, ease: 'none', scrollTrigger: scroll })
            gsap.fromTo(q('[data-sweep="back"]'), { x: () => -window.innerWidth * 0.7, rotate: 8 }, { x: () => window.innerWidth * 0.8, rotate: -6, ease: 'none', scrollTrigger: scroll })
            gsap.fromTo(q('[data-marquee="forward"]'), { xPercent: 0 }, { xPercent: -30, ease: 'none', scrollTrigger: scroll })
            gsap.fromTo(q('[data-marquee="reverse"]'), { xPercent: -30 }, { xPercent: 0, ease: 'none', scrollTrigger: scroll })
        })
    }, { scope: rootRef })

    return (
        <div
            ref={rootRef}
            aria-hidden='true'
            className='relative h-[72svh] overflow-hidden bg-[linear-gradient(180deg,#ebe5d6_0%,#eef0ea_45%,#eaf2f7_100%)] lg:h-[115vh]'
        >
            <div className='absolute inset-x-0 top-[14%] overflow-hidden whitespace-nowrap'>
                <p data-marquee='forward' className='inline-block font-heading text-[19vw] font-light italic leading-none tracking-[0.03em] text-transparent [-webkit-text-stroke:1px_rgba(29,42,51,0.16)] lg:text-[12vw]'>
                    Observation Log ✦ Summer Never Ends ✦ Observation Log ✦ Summer Never Ends ✦
                </p>
            </div>

            <div className='absolute inset-x-0 bottom-[14%] overflow-hidden whitespace-nowrap'>
                <p data-marquee='reverse' className='inline-block font-mono text-[11px] tracking-[0.5em] text-ink/45'>
                    LOG 05 — 電子世界からの通信 ✦ LOG 06 — 歌声の記録 ✦ LOG 07 — 旅の記録を持ち帰る ✦ LOG 08 — 活動記録 ✦ LOG 09 — メッセージを届ける ✦ LOG 05 — 電子世界からの通信 ✦ LOG 06 — 歌声の記録 ✦
                </p>
            </div>

            <div className='absolute inset-0 flex items-center justify-center'>
                <div data-sweep='back' className='w-[46svh] opacity-50 blur-[2px] lg:w-[44vh]'>
                    <MahoniaSprig variant='leaf' seed={31} />
                </div>
            </div>

            <div className='absolute inset-0 flex items-center justify-center'>
                <div data-sweep='main' className='w-[58svh] shrink-0 lg:w-[74vh]'>
                    <MahoniaSprig variant='branch' seed={41} />
                </div>
            </div>
        </div>
    )
}

export default PlantInterlude
